import ACTIONS from '../logic/actions';
import lookup from './lookup';

var hasDifferentBaseXPath = function hasDifferentBaseXPath(parentXPath, childXPath) {
  return parentXPath == childXPath || !(childXPath + '/').startsWith(parentXPath + '/');
};
/**
 * @param {string} fieldId
 * @param {string} context
 * @param {Array<{name:String, value:string, fieldIdWithSuffix:string}>} params
 * @param {import("../logic/types").EcrionFormState} state
 * @param {(any) => any} dispatch
 */


var linkContext = function linkContext(fieldId, context, params, state, dispatch) {
  var field = state.fields[fieldId];
  var fieldBinding = getBinding(field.originalId || field.id, state);
  var xpath = fieldBinding.xpath,
      dataSource = fieldBinding.dataSource;
  var processedRepeatings = [];
  Object.keys(state.formBindings.bindings).forEach(function (bindingId) {
    var binding = state.formBindings.bindings[bindingId]; // TODO : check for context here
    // we only try to link other bindings with same datasource

    if (dataSource !== binding.dataSource) return; // we want to set context only for child elements

    if (hasDifferentBaseXPath(xpath, binding.xpath)) return; // use this context for next lookup

    binding.context = context;
    var firstBindingField = state.fields[binding.fields[0].fieldId];
    var bindingParentField = state.fields[firstBindingField.parentId];
    if (bindingParentField.type !== 'repeating' || !bindingParentField.xpath) return;
    if (processedRepeatings.includes(bindingParentField.id)) return;
    processedRepeatings.push(bindingParentField.id);
    linkRepeatingContext(binding, bindingParentField, params, state, dispatch);
  });
};
/**
 * @param {import('./types').Binding} binding
 * @param {import("../logic/types").EcrionFormField} field
 * @param {import("../logic/types").EcrionFormRepeatingField} repeatingField
 * @param {Array<{name:String, value:string, fieldIdWithSuffix:string}>} params
 * @param {import("../logic/types").EcrionFormState} state
 * @param {(any) => any} dispatch
 */


var linkRepeatingContext = function linkRepeatingContext(binding, repeatingField, params, state, dispatch) {
  var _state$options = state.options,
      workspace = _state$options.workspace,
      jobId = _state$options.jobId;
  var xpath = binding.xpath,
      dataSource = binding.dataSource,
      context = binding.context;
  var fields = binding.fields.map(function (f) {
    return f.source;
  });
  var parameters = params.map(function (p) {
    return {
      Name: p.name,
      Value: p.value,
      Id: p.fieldIdWithSuffix
    };
  });
  lookup(workspace, dataSource, xpath, fields, parameters, {
    context: context,
    jobId: jobId || ''
  }).then(function (result) {
    var columnNames = result.columnNames,
        rows = result.rows;
    var values = [];
    var fieldsValues = {};

    for (var rowIdx = 0; rowIdx < rows.length; ++rowIdx) {
      values.push(rowIdx);
      var row = rows[rowIdx];

      for (var fieldIdx = 0; fieldIdx != binding.fields.length; ++fieldIdx) {
        var bindingField = binding.fields[fieldIdx];
        var colIdx = columnNames.indexOf(bindingField.source);
        var value = row.values[colIdx];
        if (value === null) continue;
        var field = state.fields[bindingField.fieldId];
        var fieldId = field.id + '_' + rowIdx;
        fieldsValues[fieldId] = value;
      }
    }

    if (values.length == 0) return;
    dispatch({
      type: ACTIONS.SET_REPEATING_FIELD_VALUE,
      payload: {
        fieldId: repeatingField.id,
        value: values
      }
    });
    dispatch({
      type: ACTIONS.SET_FIELDS_VALUES,
      payload: fieldsValues
    });
  });
};
/**
 * @param {string} fieldId
 * @param {import("../logic/types").EcrionFormState} state
 * @returns {import("./types").Binding}
 */


var getBinding = function getBinding(fieldId, state) {
  var formBindings = state.formBindings;
  var bindingId = formBindings.fieldsBindingMap[fieldId];
  return formBindings.bindings[bindingId];
};

export default {
  linkContext: linkContext
};